import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

import { LogoutMenuItem } from './LogoutMenuItem';


export function AdminAsideMenu() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
  to='/dashboard'
  icon='/media/icons/duotune/general/gen025.svg'
  title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
/>

<div className='menu-item'>
  <div className='menu-content pt-8 pb-2'>
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Admin</span>
  </div>
</div>

<AsideMenuItemWithSub
  to=''
  title='eCommerce'
  icon='\media\icons\duotune\ecommerce\ecm004.svg'
>
  <AsideMenuItem to='/admin/products' title='Products' hasBullet={true} />
  <AsideMenuItem to='/admin/productinstructions' title='Instructions' hasBullet={true} />
  <AsideMenuItem to='/admin/labtests' title='Lab Tests' hasBullet={true} />
  <AsideMenuItem to='/admin/labmetrics' title='Lab Metrics' hasBullet={true} />
</AsideMenuItemWithSub>

<AsideMenuItemWithSub
  to=''
  title='User Management'
  icon='\media\icons\duotune\general\gen049.svg'
>
  <AsideMenuItem to='/admin/usermanagement/users' title='Users' hasBullet={true} />
</AsideMenuItemWithSub>

<div className='menu-item'>
  <div className='menu-content'>
    <div className='separator mx-1 my-4'></div>
  </div>
</div>

<div className='menu-item'>
  <div className='menu-content pt-8 pb-2'>
    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Account & Security</span>
  </div>
</div>
  
  <AsideMenuItem
    to='/user/account/settings'
    title='Settings'
    icon='\media\icons\duotune\general\gen019.svg'
  />
  <LogoutMenuItem title='Sign Out' icon='\media\icons\custom\lock.svg' />

    </>
  )
}
